import { DATE_VALUES, getRangeFromDateFilter } from 'utils/dateUtils'

import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  bannerTypeKey,
  CREATE_INCIDENT_ASYNC,
  DATA_REQUEST_ASYNC,
  DATE_FILTER_CHANGE,
  FILTER_CHANGE,
  LIST_CLOSE,
  LIST_INIT_AND_SHOW,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
} from './constants'

const defaultFilters = {
  bannerTypeFilter: [],
  incidentTypeFilter: [],
  tagsFilter: [],
  departmentFilter: [],
  resolvedByFilter: [],
  reportedByFilter: [],
  resolutionTypeFilter: [],
  threatTypeFilter: [],
}
const initialState = {
  data: {
    items: [],
  },
  page: 1,
  loader: false,
  error: null,
  dateFilter: DATE_VALUES.MONTH,
  search: '',
  ...defaultFilters,
}

export default function () {
  return (state = initialState, action) => {
    switch (action.type) {
      case PAGINATE_CHANGE:
        return {
          ...state,
          page: action.payload.page,
          loader: true,
        }
      case LIST_INIT_AND_SHOW:
        return {
          ...state,
          loader: true,
          page: 1,
          listType: action.payload.listType,
          dateFilter: action.payload.dateFilter,
          feDateRange: getRangeFromDateFilter(action.payload.dateFilter),
          ...defaultFilters,
          ...action.payload.filters,
        }
      case FILTER_CHANGE: {
        let filters
        if (action.payload.filterName === 'incidentTypeFilter') {
          action.payload.filterValue = action.payload.filterValue.map((elem) => ({
            label: elem.label,
            value: String(elem.value),
          }))
          const itf = action.payload.filterValue
            .filter((elem) => elem.value.indexOf(bannerTypeKey) === -1)
            .map((elem) => ({ label: elem.label, value: Number(elem.value) }))
          const btf = action.payload.filterValue
            .filter((elem) => elem.value.indexOf(bannerTypeKey) !== -1)
            .map((elem) => ({
              label: elem.label,
              value: Number(elem.value.replace(bannerTypeKey, '')),
            }))

          filters = { incidentTypeFilter: itf, bannerTypeFilter: btf }
        } else {
          filters = {
            [action.payload.filterName]: [...action.payload.filterValue],
          }
        }

        return {
          ...state,
          loader: true,
          ...filters,
          page: 1,
        }
      }
      case DATE_FILTER_CHANGE:
        return {
          ...state,
          dateFilter: action.payload.dateFilter,
          feDateRange: getRangeFromDateFilter(action.payload.dateFilter),
          loader: true,
          page: 1,
        }
      case SEARCH_RESET:
        return { ...state, search: '' }
      case SEARCH_CHANGE:
        return {
          ...state,
          search: action.payload.q,
          loader: true,
          page: 1,
        }
      case LIST_CLOSE:
        return { ...state, page: 1 }

      case COMPANY_FILTER_CHANGE:
      case DATA_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
          page: 1,
        }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case DATA_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
          page: 1,
        }
      case CREATE_INCIDENT_ASYNC.INITIATE:
        return { ...state, loader: true }
      case CREATE_INCIDENT_ASYNC.SUCCESS:
        return { ...state, loader: false }
      case CREATE_INCIDENT_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case CREATE_INCIDENT_ASYNC.CANCEL:
        return { ...state, loader: false }
      default:
        return state
    }
  }
}
